
export const TOUR_EXPLORE_SUCCESS = "TOUR_EXPLORE_SUCCESS";
export const TOUR_EXPLORE_ERROR = "TOUR_EXPLORE_ERROR";
export const TOUR_EXPLORE_START = "TOUR_EXPLORE_START";